export default {
    about_management: 'About the department',
    ppp_objects: 'PPP objects',
    realized_objects: 'Realized projects',
    notfound: 'No active lots ',
    private_schools: 'Private schools',
    faq: 'FAQ',
    contact_us: 'Contact us',
    ministry: 'Ministry of preschool and school education of the Republic of Uzbekistan',
    ministry_footer: 'Ministry of preschool and school education of the Republic of Uzbekistan',
    department: 'Perspective models of schools and public-private partnership department',
    active: 'Active',
    active_1: 'Active',
    offered: 'Proposed',
    proposed_1: 'Offered',
    select_district: 'Select district',
    select_category: 'Select categories',
    select_type: 'Select types',
    select_expDate: 'Expiration date',
    select_region: 'Select region',
    date_from: 'From',
    date_to: 'To',
    more_info: 'More info',
    faqfull: 'Frequently asked questions',
    read: 'Read',
    news: 'News',
    count: 'count',
    active_objects: 'Active objects',
    site_map: 'Site map',
    webeonmark: 'Website developed by',
    main_page: 'Home',
    your_fullname: 'Your fullname',
    name: 'Name',
    lastname: 'Lastname',
    organization: 'Organization',
    your_phone: 'Your phone number',
    your_email: 'Your email',
    message: 'Your message',
    code: 'Code',
    send: 'Send',
    close: 'Close',
    city_title: 'PPP objects in',
    school: 'School №',
    contacts: 'Contacts',
    phone: 'Phone number',
    address: 'Address',
    full_address: '100187, 2a, Navoi street, Yakkasaray district, Tashkent city',
    email: 'Email',
    website: 'Website',
    working_time: 'Working time of department',
    monday: 'Mo',
    tuesday: 'Tu',
    wednesday: 'We',
    thursday: 'Th',
    friday: 'Fr',
    saturday: 'Sa',
    sunday: 'Su',
    aboutfull_1: 'The activity of the department of perspective models of schools and public-private partnership is focused on research and evaluation of the implementation of PPP investment projects in the field of public education. We provide full consulting support for projects and facilitate their implementation. An important part of our work is the formation of a base and assistance in the implementation of projects.',
    aboutfull_2: 'We effectively interact with legislative and executive authorities, local companies, international and public organizations. The main objective of the department is to create conditions for partnership between the state and business, to develop and combine their potential for the implementation of PPP projects and to increase the volume of private investment in the country\'s economy.',
    city: 'City/region',
    district: 'District',
    legal_address: 'Legal address of the object',
    total_area: 'Total area, sq.m',
    building_area: 'Building area, sq.m',
    used_area: 'Used area, sq.m',
    free_land_area: 'Free land area, sq.m',
    problems: 'Existing problems at object',
    status: 'Status',
    search: 'Search',
    language_of_instruction: 'Language of instruction',
    opening_date: 'Opening date',
    established: 'Established',
    admission_terms: 'Admission Terms',
    training_duration: 'Training duration',
    training_duration_1: 'Training duration',
    language_learning: 'Language learning',
    specialization: 'Specialization',
    local_teachers: 'Local teachers',
    foreign_teachers: 'Foreign teachers',
    sport_ground: 'Sport ground',
    security: 'Security',
    transport: 'Transport (bus)',
    school_hallmark: 'School hallmark',
    payment_for_month: 'Payment for one month of training',
    discount: 'Discount',
    schoolbook: 'The provision of teaching aids',
    food: 'Nutrition',
    extraClasses: 'After-school clubs',
    contact_number: "Contact number",
    status_0: 'Absent',
    status_1: 'Available',
    titleProblem: 'Description',
    successful_message: 'Thank you, Your message was sent to the Moderator for consideration. We will contact You shortly.',
    messages: 'Message',
    andijan: 'Andijan',
    bukhara: 'Bukhara',
    ferghana: 'Ferghana',
    Jizzakh: 'Jizzakh',
    Namangan: 'Namangan',
    Navai: 'Navai',
    Kashkadarya: 'Kashkadarya',
    Karakalpakstan: 'Karakalpakstan Republic',
    Samarqand: 'Samarkand',
    Syrdarya: 'Syrdarya',
    Surkhandarya: 'Surkhandarya',
    Tashkent_reg: 'Tashkent region',
    Tashkent_city: 'Tashkent city',
    Khorezm: 'Khorezm',
    about1: 'Quality education',
    about11: 'The importance of quality education for advancement along the path of the knowledge economy requires the provision of conditions for the formation of a national innovation system, within which integration and social interaction between the state and business is carried out.',
    about2:'Reconstruction of schools',
    about21:'Reconstruction most often involves the creation or renewal of a conceptual framework, including the socio-aesthetic, pedagogical, technological, demographic aspects of the region in which the school is located.',
    about3:'Attracting investors',
    about31:'PPP mechanisms make it possible to attract private investors to the implementation of infrastructure projects on a long-term basis between government agencies and business entities. Each of the parties contributes to the overall project, which allows the goals of both parties to be achieved in the most effective way.',
    about4:'Resource efficiency',
    about41:'Public-private partnership can be considered as a tool for solving such problems of modern education as education for children with different educational needs; pooling and raising funds to improve the quality of training programs.',
    about5:'Multilateral approach',
    about51:'A multi-stakeholder approach in PPP projects allows for a comprehensive analysis of a project before it is initiated and ensures versatility during its implementation.',
    about6:'Long term development',
    about61:'PPP projects involve cooperation between the public and private sectors in order to implement long-term investment projects in the field of public education based on the voluntary pooling of resources and the distribution of income or non-property benefits, costs and risks.',
    about0: 'What is a PPP?'
}
